import { isProjectVersionV3OrV4, isRevisionUpdatedAfterStartDate } from './shgcViewer';

export type CadDxfFeatures = {
  cadDxfAllowed?: boolean;
  cadDxfStartDate?: string | Date | null;
};

/** Org allowlist + v3/v4 + revision after feature start. Admins always pass. */
export const isCadDxfEnabled = (
  features: CadDxfFeatures | undefined,
  projectVersion: string | undefined,
  revisionUpdatedAt?: string | Date | null,
  isAdmin = false
): boolean => {
  if (isAdmin) return true;
  return !!(
    features?.cadDxfAllowed &&
    features?.cadDxfStartDate &&
    isProjectVersionV3OrV4(projectVersion) &&
    isRevisionUpdatedAfterStartDate(revisionUpdatedAt, features.cadDxfStartDate)
  );
};
